import { HeartPulse, Sparkles, Sunrise, Compass, NotebookPen, TrendingUp } from "lucide-react";

// The six premium features as shown in Ellie's conversation (keys match the backend).
export const FEATURES = [
  { key: "xray", label: "Emotional X-Ray", to: "/history/xray", Icon: HeartPulse },
  { key: "future_self", label: "Future Self", to: "/future-self", Icon: Sparkles },
  { key: "battle_plan", label: "Daily Battle Plan", to: "/history/plan", Icon: Sunrise },
  { key: "purpose", label: "Purpose Engine", to: "/history/purpose", Icon: Compass },
  { key: "journal", label: "Journal", to: "/journal", Icon: NotebookPen },
  { key: "progress", label: "Progress", to: "/progress", Icon: TrendingUp },
];

export const featureByKey = (k) => FEATURES.find((f) => f.key === k);

export const ELLIE_CHAT_PATH = "/app?chat=1";
